<script lang="ts" setup></script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      transform="rotate(-180 12 12)"
      stroke="#56CB77"
      stroke-width="2"
    />
    <path
      d="M7 10.8966L10.7143 15L17 8"
      stroke="#56CB77"
      stroke-width="2"
    />
  </svg>
</template>
